import { jsx } from "react/jsx-runtime";
import { negativeMargin } from "../../css/negativeMargin/negativeMargin.mjs";
import { Box } from "../Box/Box.mjs";
const validBleedComponents = ["div", "span"];
const Bleed = ({
  space,
  horizontal,
  vertical,
  top,
  bottom,
  left,
  right,
  children,
  component = "div"
}) => /* @__PURE__ */ jsx(
  Box,
  {
    component,
    display: component === "span" ? "block" : void 0,
    className: [
      negativeMargin("top", top || vertical || space),
      negativeMargin("bottom", bottom || vertical || space),
      negativeMargin("left", left || horizontal || space),
      negativeMargin("right", right || horizontal || space)
    ],
    children: /* @__PURE__ */ jsx(
      Box,
      {
        component,
        display: component === "span" ? "block" : void 0,
        position: "relative",
        children
      }
    )
  }
);
export {
  Bleed,
  validBleedComponents
};
